import { formatSharpCharts2DateString } from '@/utils/formatSharpCharts2DateString';
import { eraseHoursMinutesSecondsAndMilliseconds } from '@/utils/eraseHoursMinutesSecondsAndMilliseconds';

export function getFormattedYearToDateStartDate() {
  const now = eraseHoursMinutesSecondsAndMilliseconds(new Date());
  const januaryFirst = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);

  return formatSharpCharts2DateString(januaryFirst);
}
